import { Alert, Center, Loader } from '@mantine/core';
import { IconAlertTriangle } from '@tabler/icons-react';
import type { ReactNode } from 'react';

export function QueryState({ loading, error, children }: { loading: boolean; error: unknown; children: () => ReactNode }) {
  if (loading) return <Center py="xl"><Loader /></Center>;
  if (error) return <Alert color="red" icon={<IconAlertTriangle />} title="Не удалось загрузить">{(error as Error).message}</Alert>;
  return <>{children()}</>;
}
